/**
 * Default theme that loads when no user preference is set
 * Change this value to set a different default theme
 */
export const DEFAULT_THEME = "default";

export const THEMES = [
  {
    name: "Default",
    value: "default"
  },
  {
    name: "Supabase",
    value: "supabase"
  },
  {
    name: "Vercel",
    value: "vercel"
  },
  {
    name: "Claude",
    value: "claude"
  },
];